import React, { useCallback } from 'react';
import type { FC, ReactNode } from 'react';
import type { UserInfo } from '@wix/cli-auth';
import { AuthProvider as UnifiedAuthProvider } from '@wix/cli-auth';
import { addUserFields } from '@wix/cli-telemetry';
import { useBiLogger } from '@wix/cli-telemetry-react';
import { useErrorReporter } from '@wix/cli-error-reporting';
import { LoginRequiredWarning } from './LoginRequiredWarning.js';

interface Props {
  children: ReactNode;
  userInfo: UserInfo | null;
}

export const AuthProvider: FC<Props> = ({ userInfo, children }) => {
  const biLogger = useBiLogger();
  const errorReporter = useErrorReporter();

  const handleLogin = useCallback(
    (userInfo: UserInfo) => {
      errorReporter.setUser({ id: userInfo.userId });
      addUserFields(biLogger, userInfo.userId);
    },
    [biLogger, errorReporter]
  );

  return (
    <>
      {userInfo == null && <LoginRequiredWarning />}
      <UnifiedAuthProvider onLogin={handleLogin} children={children} />
    </>
  );
};
